define([
    'document-ready-promise',
    'jquery'
], function(ready, $) {

    var submenu = {
        init: function() {
            this.initialiseMegaMenu();
        },

        initialiseMegaMenu: function() {
            // toggle visibility of menus
            $('.overlay-menu-trigger').on('click', function(event) {
                $('.header-overlay').addClass("open");
                $('.overlay-menu-trigger.selected').removeClass("selected");

                var _this = $('#'+$(this).attr('menu'));
                if (_this.hasClass("open")) {
                    _this.removeClass("open");
                    $('.header-overlay').removeClass("open");
                } else {
                    $(this).addClass('selected');

                    if ($('.overlay-menu.open') && $('.overlay-menu.open').length) {
                        $('.overlay-menu.open').removeClass("open");
                        window.setTimeout(function () {
                            _this.addClass("open");
                        }, 200);
                    } else {
                        _this.addClass("open");
                    }
                }
                event.preventDefault();
                return 0;
            });
            // close menus with the x button
            $('.overlay-menu-close-icon').on('click', function(event) {
                $('.overlay-menu-trigger.selected').removeClass("selected");
                $('.overlay-menu.open').removeClass("open");
                $('.header-overlay').removeClass("open");
                event.preventDefault();
                return 0;
            });
        }
    };

    ready().then(function(){
        submenu.init();
    });
});



// WEBPACK FOOTER //
// ./resources/assets/js/teach/partials/teach-sub-menu.js